export enum Mode {
    ADD = 'add',
    EDIT = 'edit',
    VIEW = 'view'
}